import { Checkbox, UserCombobox } from '@/components'
import { DropdownNames } from '@/components_deprecated/Select/types'
import { ExportFormat } from '@/modules/exports'
import type { ExportPeriod } from '@/modules/exports/components/export-form'
import {
  ExportCard,
  ExportField,
  ExportFormatField,
  ExportMethodField,
  ExportPeriodField,
} from '@/modules/exports/components/export-form'
import { useTranslate } from '@ur-solutions/react-hooks'
import { endOfDay, startOfDay } from 'date-fns'
import { useExportInfringementsForm } from '../../hooks'

const EXCLUDED_FORMATS = [
  ExportFormat.EXCEL_FLAT,
  ExportFormat.PDF_SALARY,
  ExportFormat.POWEROFFICE,
  ExportFormat.TRIPLETEX,
  ExportFormat.TWENTYFOUR_SEVEN_OFFICE,
  ExportFormat.VISMA,
]

export const ExportInfringementsCard: React.FC = () => {
  const translations = useTranslate({
    exportAll: 'infringements.export-infringement-data',
    user: 'common.user',
    exportCompany: 'infringements.export.all',
  })

  const { loading, form, errors, submit, updateForm, handleExport, handler } =
    useExportInfringementsForm()

  function handlePeriodChange(value: Partial<ExportPeriod>) {
    updateForm({
      ...value,
      ...(value.dateStart && { dateStart: startOfDay(value.dateStart) }),
      ...(value.dateEnd && { dateEnd: endOfDay(value.dateEnd) }),
    })
  }

  return (
    <ExportCard
      title={translations.exportAll}
      loading={loading}
      onSubmit={submit(handleExport)}
    >
      <ExportPeriodField value={form} onChange={handlePeriodChange} />

      <ExportMethodField
        value={form.exportOption}
        onChange={handler('exportOption')}
      />

      <label className="flex w-fit cursor-pointer items-center gap-3 text-sm font-medium text-stone-700 md:col-span-2">
        <Checkbox
          size="sm"
          value={form.exportMass}
          onChange={() =>
            updateForm({ exportMass: !form.exportMass, user: '' })
          }
        />
        {translations.exportCompany}
      </label>

      {form.exportMass ? (
        <ExportFormatField
          value={form.exportFormat}
          exclude={EXCLUDED_FORMATS}
          onChange={handler('exportFormat')}
        />
      ) : (
        <ExportField label={translations.user} error={errors.user}>
          <UserCombobox
            mode="single"
            value={form.user ?? ''}
            dropdownPageName={DropdownNames.ACTIVITIES}
            onChange={value => updateForm({ user: value })}
          />
        </ExportField>
      )}
    </ExportCard>
  )
}
